import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { AgentAvatar } from '@atlaskit/rovo-agent-components';
import { token } from '@atlaskit/tokens';

import { isForgeAgent } from '@atlassian/conversation-assistant-agent';
import type { Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

const styles = cssMap({
	root: {
		position: 'relative',
		filter: `drop-shadow(1px 0px 0px ${token('color.icon.inverse')}) drop-shadow(-1px 0px 0px ${token('color.icon.inverse')}) drop-shadow(0px 1px 0px ${token('color.icon.inverse')}) drop-shadow(0px -1px 0px ${token('color.icon.inverse')})`,
	},
});

export type AgentPresenceAvatarProps = {
	agent: Agent;
	stackIndex?: number;
	showBorder?: boolean;
};

export const AgentPresenceAvatar = ({
	agent,
	stackIndex,
	showBorder,
}: AgentPresenceAvatarProps) => {
	return (
		<Box xcss={cx(showBorder && styles.root)} style={{ zIndex: stackIndex }}>
			<AgentAvatar
				key={agent.id}
				agentId={agent.id}
				agentIdentityAccountId={agent.identity_account_id}
				agentNamedId={agent.external_config_reference ?? agent.named_id}
				size="medium"
				showBorder={false}
				isForgeAgent={isForgeAgent(agent)}
				forgeAgentIconUrl={agent.icon}
			/>
		</Box>
	);
};
